import { Footer } from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js